import { useNavigate } from 'react-router'

export default function BillingSuccess() {
  const navigate = useNavigate()
  return (
    <div style={{ padding: '80px 0' }}>
      <div className="container" style={{ maxWidth: 480 }}>
        <div className="eyebrow" style={{ marginBottom: 14 }}><span className="num">$</span>billing</div>
        <h1 className="h1">You're upgraded.</h1>
        <p className="lede" style={{ marginTop: 14, marginBottom: 28 }}>
          Your plan is now active. Push bigger grids, keep them private, and ship faster.
        </p>
        <button className="btn btn-primary btn-lg" onClick={() => navigate('/workspace')}>
          Go to workspace →
        </button>
      </div>
    </div>
  )
}
